import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import cn from 'classnames';
import { Button, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useIoContext } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import BigConfirmationCheckmarkIcon from '~/pages/VendorDashboard/BusinessSetupWidget/BigConfirmationCheckmarkIcon.json';
import styles from './InvoiceStatusScreen.module.scss';
export const GetInvoiceStatusScreenTID = (parentTestId)=>getTestIds(parentTestId);
export const InvoiceStatusScreen = (param)=>{
    let { title, subtitle, description, onDownloadPdf, onViewInvoice, footer, animate, testId } = param;
    const { InvoiceStatusScreenTestIds } = useMemo(()=>GetInvoiceStatusScreenTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys();
    const { Lottie } = useIoContext();
    const showButtons = onDownloadPdf != null || onViewInvoice != null;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": InvoiceStatusScreenTestIds.Root(),
        className: cn(styles.screen, animate && styles.gradualReveal),
        children: [
            /*#__PURE__*/ _jsx("div", {
                "data-testid": InvoiceStatusScreenTestIds.LottieIcon(),
                className: styles.lottieIcon,
                children: /*#__PURE__*/ _jsx(Lottie, {
                    animationData: BigConfirmationCheckmarkIcon,
                    loop: false,
                    autoplay: true
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h3",
                weight: "normal",
                testId: InvoiceStatusScreenTestIds.Title(),
                children: title
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h6",
                weight: "light",
                testId: InvoiceStatusScreenTestIds.Subtitle(),
                className: styles.subtitle,
                children: subtitle
            }),
            description != null && /*#__PURE__*/ _jsx(Typography, {
                variant: "paragraph1",
                weight: "light",
                testId: InvoiceStatusScreenTestIds.Description(),
                className: styles.description,
                children: description
            }),
            showButtons && /*#__PURE__*/ _jsxs(Row, {
                className: styles.buttons,
                gap: 12,
                children: [
                    onDownloadPdf != null && /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'ad_hoc_invoice_status_download_pdf'
                        },
                        skin: "primaryOutline",
                        testId: InvoiceStatusScreenTestIds.DownloadPdfButton(),
                        onClick: onDownloadPdf,
                        children: t.common.buttons.downloadPdf()
                    }),
                    onViewInvoice != null && /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'ad_hoc_invoice_status_view_invoice'
                        },
                        skin: "primary",
                        testId: InvoiceStatusScreenTestIds.ViewInvoiceButton(),
                        onClick: onViewInvoice,
                        children: t.adHocInvoiceApproval.viewInvoice()
                    })
                ]
            }),
            footer != null && /*#__PURE__*/ _jsx("div", {
                "data-testid": InvoiceStatusScreenTestIds.Footer(),
                children: footer
            })
        ]
    });
};
